import { GlobalContext } from 'context';
import { ReactElement, Suspense, lazy } from 'react';
import { Navigate as Redirect, Route, Routes } from 'react-router-dom';
import Loading from 'shared/components/Loading/Loading';
import { navigate } from 'shared/utils/navigate';
import createPrivateRouteUsignContext from 'shared/utils/PrivateRouteCreator/PrivateRouteCreator';
import { AutenticationPath } from './routes';

const Login = lazy(() => import('./pages/Login/Login'));
const BranchOfficeList = lazy(() => import('./pages/BranchOfficeList/BranchOfficeList'));

const PrivateRoute = createPrivateRouteUsignContext({
  context: GlobalContext,
  accessWith: (context): boolean => !!context.state.login?.branchOffice,
  otherwiseRedirectTo: () => navigate('/login'),
});

export const AutenticationRoutes: React.FC = (): ReactElement => {
  return (
    <Suspense fallback={<Loading show />}>
      <Routes>
        <Route path={AutenticationPath.Login} element={<Login />} />
        <Route element={<PrivateRoute />}>
          <Route path={AutenticationPath.BranchOfficeList} element={<BranchOfficeList />} />
        </Route>
        <Route path="*" element={<Redirect to={AutenticationPath.Login} replace />} />
      </Routes>
    </Suspense>
  );
};

export const AutenticationRouter: React.FC = () => <AutenticationRoutes />;
